
/////////////////////////////////////////
/// TweenMax
/////////////////////////////////////////

globalThis.Cubic = {};
